module.exports = __webpack_public_path__ + "static/img/base-con-img-new.7506a21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lowCode/base-con-img-new.png
// module id = 2jNH
// module chunks = 0